// src/products/dataroom/components/DataroomSidebar.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Home,
  Users, 
  MessageSquare,
  UserPlus,
  Building2,
  UserCheck,
  Settings,
  Bookmark,
  Cog,
  Activity
} from 'lucide-react';
import Sidebar from '../../../components/layout/Sidebar';
import RoleService from '../../../services/roleService';

const DataroomSidebar = ({
  userRole,
  onOpenInviteModal,
  user,
  userProfile,
  selectedProjectId
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasAdminAccess = RoleService.hasAdminAccess(userRole);

  // Navigation items for Dealroom
  const navItems = [
    { icon: Home, label: 'Home', path: '/dealroom' },
    { icon: MessageSquare, label: 'Deal Questions', path: '/questions/dealrooms', openInNewTab: true },
    { icon: Bookmark, label: 'Bookmarks', path: '/dealroom/bookmarks' },
    { icon: Building2, label: 'Parties', path: '/dealroom/parties' },
    { icon: UserCheck, label: 'Teams', path: '/dealroom/teams' },
    { icon: Users, label: 'Users', path: '/dealroom/users' },
    // Permissions link: dedicated permissions management page
    { 
      icon: Settings, 
      label: 'Permissions', 
      path: '/dealroom/permissions' 
    },
  ];

  // Add project-specific activity page if a project is selected and user has admin access
  if (selectedProjectId && hasAdminAccess) {
    navItems.push({
      icon: Activity,
      label: 'User Activity',
      path: `/dealroom/${selectedProjectId}/activity`
    });
  }

  // Add project-specific settings if a project is selected
  if (selectedProjectId) {
    navItems.push({
      icon: Cog,
      label: 'Project Settings',
      path: `/dealroom/${selectedProjectId}/settings`
    });
  }


  return (
    <Sidebar
      productName="DealRooms"
      user={user}
      userProfile={userProfile}
      onBackToProducts={() => navigate('/my-account/dashboard')}
    >
      <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto" style={{ minHeight: 0 }}>
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <button
              key={item.path}
              onClick={() => {
                if (item.openInNewTab) {
                  window.open(item.path, '_blank');
                } else {
                  navigate(item.path);
                }
              }}
              className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                isActive
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              {Icon && <Icon className="w-5 h-5 mr-3 flex-shrink-0" />}
              <span className="truncate">{item.label}</span>
              {item.openInNewTab && (
                <svg className="w-3 h-3 ml-auto text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              )}
            </button>
          );
        })}

        {/* Invite Users Button - Only show for admin users */}
        {hasAdminAccess && (
          <div className="mt-4 pt-4 border-t border-gray-200">
            <button
              onClick={onOpenInviteModal}
              className="w-full flex items-center justify-center px-3 py-2 text-sm text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
            >
              <UserPlus className="w-4 h-4 mr-2" />
              <span>Invite Users</span>
            </button>
          </div>
        )}
      </nav>
    </Sidebar>
  );
};
export default DataroomSidebar;